import amapi from '@/api/amapi'

const initialState = () => ({
  ipList: [],

})

const state = initialState

const getters = {
  ipList: state => state.ipList,
}

const mutations = {
  POPULATE_IP (state, ipList) {
    state.ipList = ipList
  },
  // CLEAR_SUPPORT_STORE (state) {
  //   const s = initialState()
  //
  //   Object.keys(s).forEach(key => {
  //     state[key] = s[key]
  //   })
  // }
}

const actions = {
  async getIpList ({ commit }, _username) {
    try {
      const params = {
        api2_module: 'DenyIp',
        api2_method: 'listdenyips',
        _username,
      }

      const { data } = await amapi.cpanel_api2(params)
      commit('POPULATE_IP', data)
    } catch (e) {
      throw e
    }
  },
  async addIpToBlackList ({ commit }, { ip, _username }) {
    try {
      const params = {
        uapi_module: 'BlockIP',
        uapi_function: 'add_ip',
        ip,
        _username,
      }

      await amapi.cpanel_uapi(params)
    } catch (e) {
      throw e
    }
  },
  async removeIpFromBlackList ({ commit }, { ip, _username }) {
    try {
      const params = {
        uapi_module: 'BlockIP',
        uapi_function: 'remove_ip',
        ip,
        _username,
      }

      await amapi.cpanel_uapi(params)
    } catch (e) {
      throw e
    }
  }
}
const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
